import styled from "styled-components"

const ServicesStyled = styled.section`
  .services__icon {
    position: absolute;
    ${props => (props.iconPosition == "top" ? "top:-50px" : null)};
    ${props =>
      props.iconPosition == "middle"
        ? "top:50%; transform: translateY(-50%);"
        : null};
    ${props => (props.iconPosition == "bottom" ? "bottom:-50px" : null)};
    background: url(${props => props.icon});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    left: -30px;
    width: 210px;
    height: 210px;
  }
  .services__wrapper {
    /* padding-top: 60px; */
    position: relative;
    padding: 60px 70px 100px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    @media (max-width: 880px) {
      padding: 20px 20px 50px;
    }
  }
  .services__item {
    max-width: calc(33.33% - 35px);
    margin-right: 52.5px;
    margin-bottom: 52.5px;
    padding: 35px 20px 30px;
    box-shadow: 0 0 20px rgba(131, 131, 131, 0.2);
    text-align: center;
    position: relative;
    z-index: 5;
    background: #fff;
    &:nth-of-type(3n + 1) {
      margin-right: 0;
    }
    @media (max-width: 1280px) {
      max-width: calc(33.33% - 10px);
      margin-right: 12.5px;
    }
    @media (max-width: 1080px) {
      max-width: calc(50% - 10px);
      &:nth-of-type(3n + 1) {
        margin-right: 12.5px;
      }
      &:nth-of-type(2n + 1) {
        margin-right: 0;
      }
    }
    @media (max-width: 880px) {
      max-width: 100%;
      margin-right: 0;
      &:nth-of-type(3n + 1) {
        margin-right: 0;
      }
      &:nth-of-type(2n + 1) {
        margin-right: 0;
      }
    }
    &__icon {
      height: 65px;
      display: flex;
      align-items: flex-end;
      justify-content: center;
    }
    &__heading {
      font-size: 20px;
      font-weight: 500;
      margin: 0;
      padding-top: 15px;
      line-height: 25px;
      min-height: 2.3em;
    }
    &__description {
      font-size: 18px;
      font-weight: 300;
      p {
        margin: 0;
      }
    }
  }
`

export default ServicesStyled
